<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    item-key="name"
    class="ma-3 elevation-1"
    no-data-text="Loading..."
    hide-actions
    select-all
  >
    <v-progress-linear
      slot="progress"
      color="primary"
      indeterminate
    />
    <template v-slot:headers="props">
      <tr>
        <th>
          <v-checkbox
            :input-value="props.all"
            :indeterminate="props.indeterminate"
            primary
            hide-details
            @click.stop="toggleAll"
          />
        </th>
        <th
          v-for="header in props.headers"
          :key="header.text"
          class="text-xs-left"
        >
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <tr
        :active="props.selected"
        @click="
          props.selected = !props.selected;
          $emit('selected', props.item.id);
        "
      >
        <td>
          <v-checkbox
            :input-value="props.selected"
            primary
            hide-details
          />
        </td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.trigger }}</td>
        <td>{{ props.item.action }}</td>
        <td>
          <v-chip
            :color="props.item.active ? 'primary' : 'grey'"
            label
            small
            text-color="white"
          >
            {{ activeState(props.item.active) }}
          </v-chip>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'RulesDataTable',

  props: {
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      expand: false
    }
  },

  computed: {
    activeState () {
      return state => (state ? 'enabled' : 'disabled')
    },

    headers () {
      return [
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Trigger'), value: 'trigger' },
        { text: this.$t('Action'), value: 'action' },
        { text: this.$t('Status'), value: 'active' }
      ]
    }
  }
}
</script>
